module.exports = __webpack_public_path__ + "static/img/grad1.2061c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/icons/grad1.png
// module id = QO9C
// module chunks = 2